export const formatLongTextAsHtml = (text) => text.replace(/\n/g, '<br />');

export const formatDescriptionPreview = (text) => {
    if (text.length > 120) {
        return `${text.substring(0, 120)}...`;
    }

    return text;
};
